/**
 * EmailJS configuration — values come exclusively from environment variables.
 * Never commit real credentials here.
 *
 * Local dev:  copy .env.example → .env and fill in the values.
 * Production: set REACT_APP_EMAILJS_* in your hosting platform (Netlify / Vercel).
 *
 * Fail-fast: throws at module load time (not mid-submission) if any required
 * variable is missing, so the misconfiguration is caught immediately.
 *
 * @throws {Error} If any required REACT_APP_EMAILJS_* variable is undefined.
 */

import { EMAIL } from "./constants";

const required = /** @param {string} name @returns {string} */ (name) => {
  const value = process.env[name];
  if (!value) throw new Error(
    `[EmailJS] Missing environment variable: ${name}\n` +
    `Copy .env.example → .env and fill in your credentials.`
  );
  return value;
};

export const EMAILJS_CONFIG = {
  serviceId:  required("REACT_APP_EMAILJS_SERVICE_ID"),
  templateId: required("REACT_APP_EMAILJS_TEMPLATE_ID"),
  publicKey:  required("REACT_APP_EMAILJS_PUBLIC_KEY"),
  toEmail:    EMAIL,
};
